import '../App.css';
import Cta from '../components/Cta'
import { Link } from 'react-router-dom';
import NetworkGraph from '../components/NetworkGraph';
import Reveal from '../components/Reveal';
import ProjectCard from '../components/ProjectCard';
import portfolioProjects from '../data/Portfolioprojects';
import {
  IconGear, IconMonitor, IconHeadset, IconClipboard,
  IconGlobe, IconCloud, IconDatabase, IconChat, IconShield, IconChart,
  IconLink, IconClock,
} from '../components/Icons';

function Home() {
  return (
    <>
    {/* ═══════════════ HERO ═══════════════ */}
      <section className="hero">
        <div className="hero__bg"></div>
        <div className="hero__grid"></div>
        <NetworkGraph variant="hero" />
        <div className="hero__inner">
          <div className="hero__content">
            <div className="hero__badge animate-up">
              <span className="hero__badge-dot"></span>
              Managed Service Provider · São Paulo
            </div>
            <h1 className="hero__title animate-up animate-up--d1">
              TI que <em>funciona</em>,<br />
              para empresas que<br />
              não param.
            </h1>
            <p className="hero__subtitle animate-up animate-up--d2">
              Desde 2007 cuidamos da tecnologia de empresas paulistanas. Somos
              seu departamento de TI completo — com gestão proativa,
              segurança corporativa e infraestrutura em nuvem.
            </p>
            <div className="hero__actions animate-up animate-up--d3">
              <Link to="/contato" className="btn btn-primary">
                Falar com um especialista →
              </Link>
              <Link to="/servicos/servicos" className="btn btn-outline">
                Conhecer serviços
              </Link>
            </div>
          </div>
          <div className="hero__visual">
            <div className="hero__stats">
              <div className="stat-card stat-card--featured">
                <div className="stat-card__value">
                  <span>+17</span> anos
                </div>
                <div className="stat-card__label">
                  de experiência em TI para empresas
                </div>
              </div>
              <div className="stat-card">
                <IconGear className="stat-card__icon" />
                <div className="stat-card__value" style={{ fontSize: "24px", marginTop: "8px" }}>
                  MSP
                </div>
                <div className="stat-card__label">
                  Gestão proativa e contínua
                </div>
              </div>
              <div className="stat-card">
                <IconClock className="stat-card__icon" />
                <div className="stat-card__value" style={{ fontSize: "24px", marginTop: "8px" }}>
                  24/7
                </div>
                <div className="stat-card__label">
                  Monitoramento de endpoints
                </div>
              </div>
              <div className="stat-card">
                <IconLink className="stat-card__icon" />
                <div className="stat-card__value" style={{ fontSize: "20px", marginTop: "8px" }}>
                  Ponta a ponta
                </div>
                <div className="stat-card__label">
                  Do endpoint à nuvem, tudo gerenciado
                </div>
              </div>
              <div className="stat-card">
                <div className="stat-card__value">SP</div>
                <div className="stat-card__label">
                  Atendimento em São Paulo
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ═══════════════ SERVIÇOS ═══════════════ */}
      <section className="section section--alt">
        <div className="container">
          <Reveal className="section-header">
            <div className="section-header__text">
              <div className="tag">Serviços Gerenciados</div>
              <h2 className="section-title">
                O que a sepolTECH
                <br />
                <span className="text-blue">faz por você</span>
              </h2>
              <p className="section-subtitle">
                Tenha sua TI sob controle com gestão contínua especializada.
                Enquanto você foca no crescimento da sua empresa, nós
                garantimos a estabilidade da tecnologia.
              </p>
            </div>
            <div className="section-header__action">
              <Link to="/servicos/servicos" className="btn btn-outline">
                Ver todos os serviços →
              </Link>
            </div>
          </Reveal>
          <div className="grid-2" style={{ gap: "20px" }}>
            <Reveal as={Link} to="/servicos/gestao-ti" className="card" delay={0} style={{ "--accent": "#0066FF" }}>
              <div
                className="card__icon"
                style={{ background: "rgba(0,102,255,.12)", color: "#0066FF" }}
              >
                <IconGear />
              </div>
              <div className="card__tag" style={{ color: "#0066FF" }}>
                MSP Core
              </div>
              <div className="card__title">Gestão de TI</div>
              <div className="card__desc">
                Seu departamento de TI terceirizado. Monitoramento proativo,
                gestão de infraestrutura e suporte ilimitado em um único
                contrato mensal.
              </div>
              <span className="card__link" style={{ color: "#0066FF" }}>
                Saiba mais <span>→</span>
              </span>
            </Reveal>

            <Reveal as={Link} to="/servicos/rmm" className="card" delay={0.06} style={{ "--accent": "#4D94FF" }}>
              <div
                className="card__icon"
                style={{ background: "rgba(77,148,255,.12)", color: "#4D94FF" }}
              >
                <IconMonitor />
              </div>
              <div className="card__tag" style={{ color: "#4D94FF" }}>
                RMM
              </div>
              <div className="card__title">Gestão de Endpoints</div>
              <div className="card__desc">
                Monitoramento e gerenciamento remoto de todos os dispositivos
                da sua empresa. Atualizações, patches e alertas em tempo
                real.
              </div>
              <span className="card__link" style={{ color: "#4D94FF" }}>
                Saiba mais <span>→</span>
              </span>
            </Reveal>

            <Reveal as={Link} to="/servicos/suporte" className="card" delay={0.12} style={{ "--accent": "#0EA5E9" }}>
              <div
                className="card__icon"
                style={{ background: "rgba(14,165,233,.12)", color: "#0EA5E9" }}
              >
                <IconHeadset />
              </div>
              <div className="card__tag" style={{ color: "#0EA5E9" }}>
                Helpdesk
              </div>
              <div className="card__title">Suporte Técnico</div>
              <div className="card__desc">
                Atendimento via chamado, remoto e presencial em São Paulo.
                Resolução ágil para não parar a operação da sua empresa.
              </div>
              <span className="card__link" style={{ color: "#0EA5E9" }}>
                Saiba mais <span>→</span>
              </span>
            </Reveal>

            <Reveal as={Link} to="/servicos/consultoria" className="card" delay={0.18} style={{ "--accent": "#8B90A0" }}>
              <div
                className="card__icon"
                style={{ background: "rgba(139,144,160,.12)", color: "#8B90A0" }}
              >
                <IconClipboard />
              </div>
              <div className="card__tag" style={{ color: "#8B90A0" }}>
                Consultoria
              </div>
              <div className="card__title">Consultoria &amp; Projetos</div>
              <div className="card__desc">
                Levantamento de infraestrutura, planejamento de migração,
                implantação de sistemas e projetos sob medida para a sua
                realidade.
              </div>
              <span className="card__link" style={{ color: "#8B90A0" }}>
                Saiba mais <span>→</span>
              </span>
            </Reveal>
          </div>
        </div>
      </section>

      {/* ═══════════════ PRODUTOS ═══════════════ */}
      <section className="section">
        <div className="container">
          <Reveal className="section-header">
            <div className="section-header__text">
              <div className="tag">Produtos</div>
              <h2 className="section-title">
                Plataformas que a
                <br />
                <span className="text-blue">sepolTECH entrega</span>
              </h2>
              <p className="section-subtitle">
                Soluções em nuvem prontas para uso, com opção de gestão
                completa e suporte da sepolTECH.
              </p>
            </div>
            <div className="section-header__action">
              <Link to="/produtos/produtos" className="btn btn-outline">
                Ver todos os produtos →
              </Link>
            </div>
          </Reveal>
          <div className="grid-3" style={{ gap: "20px" }}>
            <Reveal as={Link} to="https://sepolhost.com.br/" className="card" target="_blank" delay={0} style={{ "--accent": "#E8530A" }}>
              <div
                className="card__icon"
                style={{ background: "rgba(232,83,10,.12)", color: "#E8530A" }}
              >
                <IconGlobe />
              </div>
              <div className="card__tag" style={{ color: "#E8530A" }}>
                Cloud Hosting
              </div>
              <div className="card__title">
                sepol<strong>HOST</strong>
              </div>
              <div className="card__desc">
                Hospedagem web profissional. E-mail corporativo, sites e VPS
                em nuvem com suporte incluído.
              </div>
              <span className="card__link" style={{ color: "#E8530A" }}>
                Conhecer <span>→</span>
              </span>
            </Reveal>

            <Reveal as={Link} to="/produtos/sepol-drive" className="card" delay={0.05} style={{ "--accent": "#0091FF" }}>
              <div
                className="card__icon"
                style={{ background: "rgba(0,145,255,.12)", color: "#0091FF" }}
              >
                <IconCloud />
              </div>
              <div className="card__tag" style={{ color: "#0091FF" }}>
                Private Cloud
              </div>
              <div className="card__title">
                sepol<strong>DRIVE</strong>
              </div>
              <div className="card__desc">
                Seus dados no seu servidor. Nuvem privada com Nextcloud —
                mais controle que Google Drive ou OneDrive.
              </div>
              <span className="card__link" style={{ color: "#0091FF" }}>
                Conhecer <span>→</span>
              </span>
            </Reveal>

            <Reveal as={Link} to="/produtos/sepol-backup" className="card" delay={0.1} style={{ "--accent": "#3ABEFF" }}>
              <div
                className="card__icon"
                style={{ background: "rgba(58,190,255,.12)", color: "#3ABEFF" }}
              >
                <IconDatabase />
              </div>
              <div className="card__tag" style={{ color: "#3ABEFF" }}>
                BaaS
              </div>
              <div className="card__title">
                sepol<strong>BACKUP</strong>
              </div>
              <div className="card__desc">
                Backup gerenciado em nuvem. Acontece automaticamente — você
                não precisa lembrar, nós cuidamos.
              </div>
              <span className="card__link" style={{ color: "#3ABEFF" }}>
                Conhecer <span>→</span>
              </span>
            </Reveal>

            <Reveal as={Link} to="/produtos/sepol-chat" className="card" delay={0.15} style={{ "--accent": "#00C2A0" }}>
              <div
                className="card__icon"
                style={{ background: "rgba(0,194,160,.12)", color: "#00C2A0" }}
              >
                <IconChat />
              </div>
              <div className="card__tag" style={{ color: "#00C2A0" }}>
                CX Platform
              </div>
              <div className="card__title">
                sepol<strong>CHAT</strong>
              </div>
              <div className="card__desc">
                Plataforma omnichannel de atendimento. WhatsApp e mais canais
                em uma única tela para toda a equipe.
              </div>
              <span className="card__link" style={{ color: "#00C2A0" }}>
                Conhecer <span>→</span>
              </span>
            </Reveal>

            <Reveal as={Link} to="/produtos/sepol-security" className="card" delay={0.2} style={{ "--accent": "#7B3FF2" }}>
              <div
                className="card__icon"
                style={{ background: "rgba(123,63,242,.12)", color: "#7B3FF2" }}
              >
                <IconShield />
              </div>
              <div className="card__tag" style={{ color: "#7B3FF2" }}>
                EPP + EDR
              </div>
              <div className="card__title">
                sepol<strong>SECURITY</strong>
              </div>
              <div className="card__desc">
                Bitdefender GravityZone gerenciado. Proteção corporativa de
                endpoint com detecção e resposta a ameaças avançadas.
              </div>
              <span className="card__link" style={{ color: "#7B3FF2" }}>
                Conhecer <span>→</span>
              </span>
            </Reveal>

            <Reveal as={Link} to="/produtos/erp" className="card" delay={0.25} style={{ "--accent": "#22C55E" }}>
              <div
                className="card__icon"
                style={{ background: "rgba(34,197,94,.12)", color: "#22C55E" }}
              >
                <IconChart />
              </div>
              <div className="card__tag" style={{ color: "#22C55E" }}>
                SaaS ERP
              </div>
              <div className="card__title">
                <strong>ERP</strong> Bruning
              </div>
              <div className="card__desc">
                Sistema de gestão empresarial integrado. Implantação,
                treinamento e suporte contínuo pela sepolTECH.
              </div>
              <span className="card__link" style={{ color: "#22C55E" }}>
                Conhecer <span>→</span>
              </span>
            </Reveal>
          </div>
        </div>
      </section>

      {/* ═══════════════ POR QUE SEPOLTECH ═══════════════ */}
      <section className="section section--alt">
        <div className="container">
          <div className="grid-2col-hero">
            <Reveal>
              <div className="tag">Por que a sepolTECH</div>
              <h2 className="section-title">
                Mais de <span className="text-blue">17 anos</span>
                <br />
                conectando soluções
              </h2>
              <p
                className="section-subtitle"
                style={{ marginBottom: "36px" }}
              >
                Fundada em 2007, a sepolTECH nasceu para ser o parceiro de TI
                que pequenas e médias empresas de São Paulo precisavam —
                confiável, proativo e humano.
              </p>
              <div className="feature-list">
                <div className="feature-item">
                  <div className="feature-item__icon">✓</div>
                  <span>
                    Gestão proativa — identificamos problemas antes que
                    virem incidentes
                  </span>
                </div>
                <div className="feature-item">
                  <div className="feature-item__icon">✓</div>
                  <span>
                    Portfólio completo de serviços e produtos próprios em
                    nuvem
                  </span>
                </div>
                <div className="feature-item">
                  <div className="feature-item__icon">✓</div>
                  <span>
                    Atendimento presencial em São Paulo, suporte remoto
                    imediato
                  </span>
                </div>
                <div className="feature-item">
                  <div className="feature-item__icon">✓</div>
                  <span>
                    Equipe certificada em segurança, nuvem e infraestrutura
                  </span>
                </div>
                <div className="feature-item">
                  <div className="feature-item__icon">✓</div>
                  <span>
                    Parceiro Bitdefender e Bruning — tecnologia de primeiro
                    nível
                  </span>
                </div>
              </div>
              <div style={{ marginTop: "36px" }}>
                <Link to="/sobre" className="btn btn-outline">
                  Conheça nossa história →
                </Link>
              </div>
            </Reveal>
            <Reveal delay={0.1}>
              <div className="grid-2col-stats">
                <div
                  className="card"
                  style={{ textAlign: "center", padding: "28px 20px" }}
                >
                  <div
                    style={{
                      fontFamily: "var(--font-mono)",
                      fontSize: "40px",
                      fontWeight: 700,
                      color: "var(--brand-blue)",
                      letterSpacing: "-.02em",
                    }}
                  >
                    2007
                  </div>
                  <div
                    style={{
                      fontSize: "13px",
                      color: "var(--text-muted)",
                      marginTop: "6px",
                    }}
                  >
                    Ano de fundação
                  </div>
                </div>
                <div
                  className="card"
                  style={{ textAlign: "center", padding: "28px 20px" }}
                >
                  <div
                    style={{
                      fontFamily: "var(--font-mono)",
                      fontSize: "40px",
                      fontWeight: 700,
                      color: "var(--brand-blue)",
                      letterSpacing: "-.02em",
                    }}
                  >
                    MSP
                  </div>
                  <div
                    style={{
                      fontSize: "13px",
                      color: "var(--text-muted)",
                      marginTop: "6px",
                    }}
                  >
                    Provedor gerenciado
                  </div>
                </div>
                <div
                  className="card"
                  style={{ textAlign: "center", padding: "28px 20px" }}
                >
                  <div
                    style={{
                      fontFamily: "var(--font-mono)",
                      fontSize: "40px",
                      fontWeight: 700,
                      color: "var(--brand-blue)",
                      letterSpacing: "-.02em",
                    }}
                  >
                    6+
                  </div>
                  <div
                    style={{
                      fontSize: "13px",
                      color: "var(--text-muted)",
                      marginTop: "6px",
                    }}
                  >
                    Produtos próprios
                  </div>
                </div>
                <div
                  className="card"
                  style={{
                    textAlign: "center",
                    padding: "28px 20px",
                    background:
                      "linear-gradient(135deg,rgba(0,102,255,.12),rgba(0,58,153,.04))",
                    borderColor: "rgba(0,102,255,.25)",
                  }}
                >
                  <div
                    style={{
                      fontFamily: "var(--font-mono)",
                      fontSize: "40px",
                      fontWeight: 700,
                      color: "var(--brand-blue)",
                      letterSpacing: "-.02em",
                    }}
                  >
                    SP
                  </div>
                  <div
                    style={{
                      fontSize: "13px",
                      color: "var(--text-muted)",
                      marginTop: "6px",
                    }}
                  >
                    São Paulo
                  </div>
                </div>
              </div>
            </Reveal>
          </div>
        </div>
      </section>

      {/* ═══════════════ DIFERENÇA SERVIÇO vs PRODUTO ═══════════════ */}
      <section className="section">
        <div className="container">
          <Reveal className="text-center" style={{ marginBottom: "56px" }}>
            <div className="tag">Como funciona</div>
            <h2 className="section-title">
              Serviço ou Produto?
              <br />
              <span className="text-blue">Entenda a diferença</span>
            </h2>
          </Reveal>
          <div
            className="grid-2"
            style={{ gap: "24px", maxWidth: "900px", margin: "0 auto" }}
          >
            <Reveal
              className="card"
              style={{ "--accent": "#0066FF", padding: "40px" }}
            >
              <div
                className="card__icon"
                style={{ background: "rgba(0,102,255,.12)", color: "#0066FF", marginBottom: "16px" }}
              >
                <IconGear />
              </div>
              <h3
                style={{
                  fontFamily: "var(--font-display)",
                  fontSize: "22px",
                  fontWeight: 700,
                  marginBottom: "12px",
                }}
              >
                Serviços
              </h3>
              <p
                style={{
                  color: "var(--text-secondary)",
                  fontSize: "15px",
                  lineHeight: "1.7",
                  marginBottom: "24px",
                }}
              >
                O que a{" "}
                <strong style={{ color: "var(--text-primary)" }}>
                  sepolTECH faz por você
                </strong>
                . Contratos de gestão contínua onde nossa equipe cuida da
                sua infraestrutura, resolve problemas e garante a
                estabilidade do seu ambiente de TI.
              </p>
              <ul
                style={{ display: "flex", flexDirection: "column", gap: "8px" }}
              >
                <li style={{ fontSize: "14px", color: "var(--text-muted)" }}>
                  → Gestão de TI (MSP)
                </li>
                <li style={{ fontSize: "14px", color: "var(--text-muted)" }}>
                  → RMM / Endpoints
                </li>
                <li style={{ fontSize: "14px", color: "var(--text-muted)" }}>
                  → Suporte Técnico
                </li>
                <li style={{ fontSize: "14px", color: "var(--text-muted)" }}>
                  → Consultoria &amp; Projetos
                </li>
              </ul>
              <div style={{ marginTop: "28px" }}>
                <Link to="/servicos/servicos" className="btn btn-primary">
                  Ver Serviços →
                </Link>
              </div>
            </Reveal>
            <Reveal
              className="card"
              delay={0.1}
              style={{ "--accent": "#0091FF", padding: "40px" }}
            >
              <div
                className="card__icon"
                style={{ background: "rgba(0,145,255,.12)", color: "#0091FF", marginBottom: "16px" }}
              >
                <IconCloud />
              </div>
              <h3
                style={{
                  fontFamily: "var(--font-display)",
                  fontSize: "22px",
                  fontWeight: 700,
                  marginBottom: "12px",
                }}
              >
                Produtos
              </h3>
              <p
                style={{
                  color: "var(--text-secondary)",
                  fontSize: "15px",
                  lineHeight: "1.7",
                  marginBottom: "24px",
                }}
              >
                O que a{" "}
                <strong style={{ color: "var(--text-primary)" }}>
                  sepolTECH entrega para você usar
                </strong>
                . Plataformas e softwares em nuvem com assinatura mensal,
                todos gerenciados e suportados pela nossa equipe.
              </p>
              <ul
                style={{ display: "flex", flexDirection: "column", gap: "8px" }}
              >
                <li style={{ fontSize: "14px", color: "var(--text-muted)" }}>
                  → sepolHOSTING · sepolDRIVE · sepolBACKUP
                </li>
                <li style={{ fontSize: "14px", color: "var(--text-muted)" }}>
                  → sepolCHAT · sepolSECURITY
                </li>
                <li style={{ fontSize: "14px", color: "var(--text-muted)" }}>
                  → ERP Bruning
                </li>
              </ul>
              <div style={{ marginTop: "28px" }}>
                <Link to="/produtos/produtos" className="btn btn-outline">
                  Ver Produtos →
                </Link>
              </div>
            </Reveal>
          </div>
        </div>
      </section>

      {/* ═══════════════ PORTFÓLIO ═══════════════ */}
      <section className="section section--alt">
        <div className="container">
          <div className="grid-2col-asym">
            <Reveal>
              <div className="tag">Portfólio</div>
              <h2 className="section-title">
                Sites e sistemas que
                <br />
                <span className="text-blue">já colocamos no ar</span>
              </h2>
              <p className="section-subtitle" style={{ marginBottom: "32px" }}>
                Além de cuidar da infraestrutura de TI, também desenvolvemos
                sites institucionais, lojas virtuais e sistemas sob medida
                para os nossos clientes — do design ao lançamento, com
                suporte contínuo depois que o projeto vai ao ar.
              </p>
              <Link to="/portfolio" className="btn btn-primary">
                Ver portfólio completo →
              </Link>
            </Reveal>
            <Reveal delay={0.1}>
              <div className="portfolio-teaser-grid">
                {portfolioProjects.slice(0, 3).map((project, i) => (
                  <ProjectCard
                    key={project.title}
                    project={project}
                    delay={i * 0.06}
                    compact
                  />
                ))}
              </div>
            </Reveal>
          </div>
        </div>
      </section>

      <Cta></Cta>
    </>
  );
}

export default Home;
